var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkingSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#FFA177",
    stroke: "#FFA177"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8999 6.67324L5.63324 9.0999L9.0999 3.8999",
    fill: "#FFA177"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8999 6.67324L5.63324 9.0999L9.0999 3.8999",
    stroke: "url(#paint0_linear_4444_11804)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4444_11804",
    x1: 6.4999,
    y1: 3.8999,
    x2: 6.4999,
    y2: 9.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkingSelected);
export default __webpack_public_path__ + "static/media/MarkingSelected.ac98fc26013695ff00655ec6604e8c45.svg";
export { ForwardRef as ReactComponent };